"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComponentsFields = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const form_date_time_field_1 = require("../../../composite/form/fields/form-date-time-field");
const form_file_field_1 = require("../../../composite/form/fields/form-file-field");
const form_panel_1 = require("../../../composite/form/fields/form-panel");
const form_select_1 = require("../../../composite/form/fields/form-select");
const identifier_1 = require("../common/identifier");
const ess_api_1 = require("../ess-api");
/**
 * fixme: add document
 */
function ComponentsFields() {
    const types = (0, ess_api_1.useComponentTypes)();
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(form_panel_1.FormPanel, { label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "ESS_COMPONENTS_PANEL_TITLE", defaultMessage: "Komponenta" }) },
            react_1.default.createElement(form_date_time_field_1.FormDateTimeField, { name: "syncTime", label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "ESS_COMPONENTS_FIELD_LABEL_RECORD_SYNC_TIME", defaultMessage: "\u010Cas synchronizace" }) }),
            react_1.default.createElement(form_select_1.FormSelect, { name: "type", label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "ESS_COMPONENTS_FIELD_LABEL_TYPE", defaultMessage: "Type" }), valueIsId: true, source: types, tooltipMapper: (o) => o.name }),
            react_1.default.createElement(form_file_field_1.FormFileField, { name: "file", label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "ESS_COMPONENTS_FIELD_LABEL_FILE", defaultMessage: "Soubor" }) })),
        react_1.default.createElement(identifier_1.Identifier, null)));
}
exports.ComponentsFields = ComponentsFields;
//# sourceMappingURL=components-fields.js.map